export const fastContactUs = {
  name: "",
  phone: "",
};
